import "./template/theme.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter } from "react-router-dom";
import createStore from "./store";
import { Provider as StoreProvider } from "react-redux";
import Security from "./components/Security/Security";
import "react-datepicker/dist/react-datepicker.css";
import InstallPWA from "./components/InstallPWA/InstallPWA";

export const store = createStore();
const {REACT_APP_BASE_URL} = process.env;

function App() {
  return (
    <>
      <InstallPWA></InstallPWA>
      <StoreProvider store={store}>
        <BrowserRouter basename={REACT_APP_BASE_URL}>
          <Security />
        </BrowserRouter>
      </StoreProvider>
    </>
  );
}

export default App;
